var _circle, _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 13.5,
    cy: 13.5,
    r: 13.5,
    fill: "#EBFFEB"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_0_4552",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 4,
    width: 18,
    height: 18
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5,
    y: 4,
    width: 18,
    height: 18,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_0_4552)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.5 21.9997V19.7497H21.5V21.9997H6.5ZM9.5 16.3099H10.4274L16.6524 10.0963L16.1808 9.61761L15.7136 9.15749L9.5 15.3825V16.3099ZM8.375 17.4349V14.9036L16.7823 6.50792C16.8909 6.3993 17.0142 6.31711 17.1523 6.26136C17.2901 6.20561 17.4336 6.17773 17.5828 6.17773C17.732 6.17773 17.8765 6.20561 18.0163 6.26136C18.156 6.31711 18.2841 6.40317 18.4004 6.51955L19.3019 7.43249C19.4183 7.54111 19.5024 7.66555 19.5543 7.8058C19.6062 7.94592 19.6321 8.0908 19.6321 8.24042C19.6321 8.38067 19.6058 8.52011 19.5532 8.65873C19.5006 8.79748 19.4168 8.9243 19.3019 9.03917L10.9062 17.4349H8.375ZM16.6524 10.0963L16.1808 9.61761L15.7136 9.15749L16.6524 10.0963Z",
    fill: "#071E3E"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.3db013867f9721d6b0b992a2c3af0ed5.svg";
export { ForwardRef as ReactComponent };